// i18n area 'backups' — locale uk-UA (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/backups.uk-UA.meta.json.
import type { enUS } from './backups'

export const ukUA: typeof enUS = {
  ckpt: {
    contents: 'Приймає',
    contentsHint:
      'Що сюди може лягти. «Checkpoints» — це конфігурація кластера, «Резервні копії даних» — копії віртуальних машин: два прочитання складаються, одне призначення може приймати обидва.',
    content: { checkpoints: 'Checkpoints', backups: 'Резервні копії даних' },
    destinationsTitle: 'Цілі резервного копіювання',
    checkpointsTitle: 'Контрольні точки',
    restoreTitle: 'Відновлення',
    addDestination: 'Додати ціль',
    addDestinationTitle: 'Додати ціль резервного копіювання',
    editDestinationTitle: 'Змінити ціль',
    storage: 'Сховище',
    storageHint:
      'Сховище файлового типу (dir/NFS/CIFS/CephFS) — артефакти є звичайними файлами у просторі імен платформи.',
    schedule: 'Розклад',
    scheduleNone: 'Лише вручну',
    scheduleHourly: 'Щогодини',
    scheduleDaily: 'Щодня',
    scheduleWeekly: 'Щотижня',
    scheduleHour: 'Година',
    scheduleWeekday: 'День тижня',
    scheduleHint:
      'У контрольних точок за розкладом немає оператора, який ввів би майстер-пароль: секрети зі сховища ключів пакуються як плейсхолдери.',
    retention: 'Політика зберігання',
    retentionHint:
      'Скільки запланованих контрольних точок тримати — механізм очищення видаляє найстаріші понад цю кількість. Контрольні точки, зроблені вручну, і точки перед відновленням не видаляються ніколи.',
    paused: 'На паузі',
    pausedHint:
      'Блекаут оператора: поки триває пауза, на цій цілі нічого не планується й нічого не проріджується — і політики даних, і контрольні точки. Прогони, що тривають, ніколи не чіпаються.',
    orphanRuns: '{n} осиротілих запусків',
    orphanRunsHint:
      'Заплановані запуски policy, яких більше немає на цьому призначенні: жодна retention ними не керує — ніколи не рахуються й не підрізаються — і видаляє їх лише рука. Лінза «backups» у tvirt diagnose називає видалені policy.',
    rescan: 'Повторно прийняти артефакти',
    rescanTitle: 'Повторне прийняття артефактів {name}',
    rescanHint:
      'Відбудовує каталог резервних копій (VM/CT/App) з маніфестів артефактів на призначенні. Наявні рядки ніколи не змінюються; копії невідомих політик лишаються сиротами (ніколи не видаляються автоматично). Крок після bootstrap-відновлення.',
    masterpassDrWarning:
      'Сценарій катастрофи: диски LUKS повертаються ЛИШЕ з чекпоінта З майстер-паролем. Заплановані чекпоінти пакують заглушки — періодично робіть ручний чекпоінт із майстер-паролем.',
    policy: {
      title: 'Політики резервного копіювання даних',
      hint: 'Іменовані політики: які об’єкти (kind, теги, scope), як часто, коли прогін може стартувати і скільки копій тримати. Жест зарахування лишається за власником об’єкта: теги призначаються на його власному scope.',
      add: 'Додати політику',
      column: 'Політики даних',
      name: 'Назва',
      nameHint:
        'Мітка policy, унікальна в межах призначення. Запуски йдуть за стабільним id policy: перейменування безкоштовне; видалення робить її запуски сиротами (більше не рахуються й не підрізаються).',
      kindLocked: 'Родину об’єктів наявної policy не можна змінити: створіть нову policy.',
      kindLabel: 'Об’єкти',
      kind: { vm: 'Віртуальні машини', ct: 'Контейнери', app: 'Застосунки' },
      tags: 'Селектор тегів',
      tagsHint: 'Пари tag=значення через кому, за AND. Порожні теги і scope не вибирають нічого — ніколи «все».',
      scopes: 'Scope',
      scopesHint: 'Шляхи scope (піддерева), через кому, між собою за OR.',
      windowStart: 'Вікно з',
      windowEnd: 'Вікно до',
      windowHint:
        'Вікно виконання (HH:MM, місцевий час; початок після кінця переступає північ). Воно керує лише СТАРТОМ: прогін, що вилазить за вікно, ніколи не вбивається.',
      mode: 'Режим',
      modeHint: 'Інкрементальний їде на родині серій; розірвана серія деградує до full, сказано в журналі.',
      modeFull: 'Full',
      modeIncremental: 'Інкрементальний',
      requireQuiesce: 'Вимагати quiesce (guest agent)',
      paused: 'Політика на паузі',
      retentionNone: 'Тримати все',
      retentionCount: 'Кількість',
      retentionGfs: 'Кільця GFS',
      gfs: { keepLast: 'Останні', daily: 'Денні', weekly: 'Тижневі', monthly: 'Місячні', yearly: 'Річні' },
      gfsHint:
        'Для кожного кільця тримається найновіша копія кожного з останніх N періодів. Утримувана копія тримає живим увесь свій ланцюжок — ніколи база з сиротами.',
      lastRun: 'Останній прогін',
      neverRan: 'ніколи не виконувалася'
    },
    lastCheckpoint: 'Остання контрольна точка',
    neverRun: 'Ніколи не створювалася',
    createNow: 'Створити контрольну точку',
    createNowTitle: 'Створити контрольну точку — {name}',
    masterpass: 'Майстер-пароль',
    masterpassHint:
      'Захищає значення секретів у сховищі ключів (argon2id → AES-256-GCM, для кожного значення). Він ніколи не зберігається: збережіть його — без нього відновлення дає плейсхолдери замість справжніх секретів.',
    masterpassEmptyHint: 'Залиште порожнім, щоб запакувати явні плейсхолдери замість секретів.',
    createStarted: 'Створення контрольної точки триває…',
    destinationInUseError: '«{name}» ще містить контрольні точки — спершу видаліть їх.',
    origin: 'Походження',
    originManual: 'вручну',
    originSchedule: 'за розкладом',
    originPreRestore: 'перед відновленням',
    originPreChange: 'перед зміною',
    preChangeRetention: 'Чекпоінти перед зміною',
    preChangeRetentionHint:
      'Порожньо = вимкнено. Перший запис конфігурації після періоду тиші фіксує тут попередній стан (походження «перед зміною»); найновіші зберігаються до заданої кількості — власна, обрізувана ретенція.',
    diffTitle: 'Попередній перегляд змін',
    diffFailed: 'Перегляд не вдався',
    diffRetry: 'Повторити',
    diffCounts: '{changed} зміниться · {missing} буде створено · {extra} зайвих · {equal} ідентичні',
    diffChanged: 'змінюється',
    diffMissing: 'буде створено',
    diffExtra: 'буде видалено',
    diffJsonb: 'посилання в jsonb неможливо перевірити до застосування',
    diffSecret: 'запечатані поля, непорівнянні',
    diffMore: 'ще {n}…',
    diffNeeded: 'Запуск активується, коли перегляд відображає вибір.',
    phase: 'Стан',
    phaseRunning: 'виконується',
    phaseComplete: 'завершено',
    phaseError: 'помилка',
    secrets: 'Секрети',
    secretsMasterpass: 'майстер-пароль',
    secretsPlaceholders: 'плейсхолдери',
    size: 'Розмір',
    created: 'Створено',
    destination: 'Ціль',
    download: 'Завантажити .tvbk',
    deleteCheckpoint: 'Видалити контрольну точку',
    noCheckpoints: 'Контрольних точок ще немає — створіть одну з якоїсь цілі.',

    // Раунд #156 (стандартний діалог): повна поверхня читання запису резервної
    // копії — рядки деталей для полів, які ніколи не показувала таблиця.
    families: 'Родини',
    generation: 'Покоління',
    completedAt: 'Завершено',
    errorDetail: 'Деталі помилки',
    manifest: 'Маніфест',
    restoreHint: 'Вивантажте артефакт .tvbk: оглядач покаже, що він містить, а далі ви обираєте, що відновлювати і як.',
    uploadFile: 'Вивантажити файл .tvbk',
    uploading: 'Вивантаження…',
    uploadFailed: 'Не вдалося відкрити артефакт',
    explorerTitle: 'Вміст контрольної точки',
    checkpointFrom: 'Контрольна точка кластера {cluster}, створена {when} ({origin}, покоління {generation})',
    otherCluster:
      'Цю контрольну точку створено на ІНШОМУ кластері ({cluster}) — відновлення між кластерами з’явиться в майбутньому раунді.',
    encrypted: 'зашифровано',
    objectsCount: '{n} об’єктів',
    mode: 'Режим',
    modeMerge: 'Об’єднання — узгодження: вставка або оновлення вибраних рядків, нічого не видаляється',
    modeOverwrite:
      'Перезапис — перемагає контрольна точка: повністю вибрана родина замінюється цілком (поточні рядки, яких немає в контрольній точці, зникають)',
    restoreMasterpassHint:
      'Майстер-пароль, з яким було створено цю контрольну точку. Без нього зашифровані секрети відновлюються як явні плейсхолдери.',
    checkMasterpass: 'Перевірити',
    masterpassOk: 'Майстер-пароль правильний',
    masterpassWrong: 'Майстер-пароль неправильний',
    parachuteDestination: 'Ціль-парашут',
    parachuteHint:
      'Перш ніж торкнутися будь-якого рядка, завдання створює тут автоматичну контрольну точку перед відновленням.',
    summaryTitle: 'Що станеться',
    summaryLine: '{family}: {what} — {mode}',
    summaryWhole: 'уся родина',
    summaryObjects: '{n} вибраних об’єктів',
    confirmHint:
      'Введіть назву кластера ({name}) для підтвердження — відновлення переписує задекларовану конфігурацію.',
    confirmField: 'Назва кластера',
    startRestore: 'Відновити',
    restoreRunning: 'Відновлення триває…',
    restoreDone: 'Відновлення завершено — механізми узгодження сходяться на новій декларації.',
    restoreFailed: 'Відновлення завершилося помилкою',
    discard: 'Відкинути',
    selectionEmpty: 'Виберіть принаймні одну родину або об’єкт.'
  },

  backup: {
    intro: {
      title: 'Резервне копіювання даних ВМ і контейнерів',
      subtitle: 'Цеглинки, якими користується зовнішнє ПЗ резервного копіювання',
      whatItIs:
        'TVirt надає чотири примітиви: узгоджені (quiesced) знімки, відстеження змін для кожного диска, NBD-експорт лише для читання та експорт конфігурації. Керують ними Veeam, Bacula, Acronis та їм подібні.',
      whatItIsNot:
        'TVirt — не продукт резервного копіювання: він нічого не планує, не застосовує політик зберігання і не тримає архівів ваших даних. Зберігання, каталоги та політики відновлення лишаються за ПЗ, яким ви вже користуєтеся.'
    },
    cbt: {
      title: 'Відстеження змін',
      colVm: 'ВМ',
      colDisk: 'Диск',
      colState: 'Стан',
      colBitmaps: 'Бітмапи',
      colObservedAt: 'Спостережено',
      colChangeId: 'Change ID',
      colMechanic: 'Механізм',
      stateActive: 'Активно',
      stateInactive: 'Вимкнено',
      stateInconsistent: 'Неузгоджено — наступна копія має бути повною',
      stateBroken: 'Ланцюг розірвано — вимкніть, потім увімкніть як новий ланцюг',
      stateSnapshots: 'Завжди увімкнено — дельта між знімками',
      stateUnavailable: 'Недоступно на цьому диску',
      mechanic: {
        'qcow2-bitmap': 'Бітмапа qcow2',
        'rbd-snapdiff': 'Diff знімків Ceph',
        'lvm-thin-delta': 'Дельта thin pool',
        none: 'Немає'
      },
      empty:
        'Немає дисків ВМ. Відстеження читається по дисках: увімкніть його на диску qcow2 або робіть знімки на rbd/SAN.',
      chainBroken: 'Ланцюг розірвано',
      chainBrokenText:
        'Розірвано подією {reason}: {bitmaps}. Вимкніть бітмапу (ланцюг втрачено, наступна копія повна), потім увімкніть її як новий ланцюг.',
      lineages: 'Епохи',
      epochFrozen: 'заморожена у знімку {snapshot}',
      epochLost: 'втрачена ({cause})',
      epochRecording: 'записує на голові',
      milestones: 'Віхи (знімки)',
      enable: 'Увімкнути відстеження',
      disable: 'Вимкнути',
      reset: 'Скинути',
      changedAreas: 'Змінені області',
      denied: 'У вас немає дозволу на цій ВМ',
      enableTitle: 'Увімкнути відстеження змін',
      disableTitle: 'Вимкнути відстеження змін',
      resetTitle: 'Скинути бітмапу',
      areasTitle: 'Змінені області',
      bitmapName: 'Назва бітмапи',
      bitmapNameHint: 'Власна назва: tvirt- і tvbk- належать платформі',
      granularity: 'Гранулярність (байти)',
      granularityHint: 'Степінь двійки; типово 65536',
      bitmap: 'Бітмапа',
      disableHint: 'Видаляє бітмапу і всю історію її епох: наступна копія має бути повною.',
      resetHint: 'Очищає бітмапу — нова база: change ID, старший за скидання, більше не складається.',
      areasFrom: 'Від знімка',
      areasTo: 'До знімка',
      areasRun: 'Обчислити',
      areasResult: '{count} змінених областей, {bytes}',
      areasEmpty: 'Між двома знімками немає змінених областей',
      areasZero: 'нулі',
      areasMore: 'показано перші {shown} з {count}',
      submit: 'Підтвердити',
      error: 'Дія відстеження не вдалася'
    },
    exports: {
      title: 'Відкриті експорти NBD',
      colVm: 'ВМ',
      colDisk: 'Диск',
      colSnapshot: 'Знімок',
      colBitmap: 'Бітмапа',
      colPhase: 'Фаза',
      colNode: 'Вузол',
      colEndpoint: 'Endpoint',
      colExpires: 'Спливає',
      colCreated: 'Відкрито',
      colError: 'Помилка',
      phase: {
        preparing: 'Підготовка',
        ready: 'Готовий',
        closed: 'Закритий',
        error: 'Невдалий'
      },
      expiresIn: 'через {minutes} хв',
      expired: 'сплив',
      empty: 'Експортів немає. Сесія читання віддає один диск в одному знімку NBD-клієнту; сесія запису заповнює незайманий диск зупиненої ВМ. Обидві гинуть після закінчення терміну.',
      endpointHint: 'TLS з CA кластера; назва експорту — це квиток, він гине разом із сесією',
      closeDenied: 'У вас немає дозволу закривати експорти цієї ВМ',
      open: 'Відкрити експорт NBD',
      openTitle: 'Відкрити експорт NBD',
      openDisk: 'Диск',
      openBitmap: 'Бітмапа (необов’язково)',
      openBitmapHint:
        'Публікує епоху цієї бітмапи, заморожену в цьому знімку, як meta-context змінених екстентів (лише диски qcow2)',
      openTtl: 'Тривалість (хвилини)',
      openSubmit: 'Відкрити',
      openError: 'Не вдалося відкрити експорт',
      colMode: 'Режим',
      mode: {
        read: 'Читання',
        write: 'Запис'
      },
      caCertificate: 'CA кластера',
      caCopy: 'Копіювати PEM',
      caDownload: 'Завантажити ca-cert.pem',
      caHint: 'Запишіть PEM у ca-cert.pem в приватному каталозі та підключайтеся через nbds://…?tls-certificates=<каталог> (nbdcopy, nbdinfo) або --object tls-creds-x509,dir=<каталог>,endpoint=client (qemu-img)',
      caAbsent: 'Сесія не несе CA (немає PKI)',
      openWrite: 'Відкрити експорт на запис',
      openWriteTitle: 'Відкрити експорт на запис',
      openWriteIntro: 'Диск має бути незайманим: народжений порожнім, ніколи не записаний, без знімка; ВМ зупинена. Відновлення ЗАПОВНЮЄ диск, а не ремонтує його. Поки сесія відкрита, ВМ не запускається, не робить знімок, не клонується, а диск не переміщується.',
      openWriteSubmit: 'Відкрити',
      openWriteError: 'Не вдалося відкрити експорт на запис',
      openWriteDenied: 'Вам бракує vm.restore.data на цій ВМ',
      openWriteStopped: 'Зупиніть ВМ, щоб відкрити експорт на запис',
      fromDescription: 'Створити ВМ з опису',
      fromDescriptionTitle: 'Створити ВМ з опису',
      fromDescriptionIntro: 'Опис з export-vm-meta повертається зупиненою ВМ з порожніми дисками описаної геометрії — готовою до експортів на запис, диск за диском. Байти тут не проходять: їх несе restore-disk (CLI) або NBD-клієнт продукту резервного копіювання.',
      fromDescriptionDoc: 'Опис (JSON)',
      fromDescriptionDocHint: 'Вставте документ export-vm-meta або виберіть файл',
      fromDescriptionFile: 'Вибрати файл…',
      fromDescriptionInvalid: 'Текст не є JSON-документом',
      fromDescriptionName: 'Ім\'я нової ВМ',
      fromDescriptionScope: 'Scope',
      fromDescriptionScopeHome: 'Ваш домашній scope',
      fromDescriptionStorage: 'Сховище дисків',
      fromDescriptionStorageHint: 'Кожен диск народжується тут, у типовому форматі сховища',
      fromDescriptionMetadataStorage: 'Сховище метаданих',
      fromDescriptionSameAsStorage: 'Те саме, що й для дисків',
      fromDescriptionBridge: 'Міст',
      fromDescriptionBridgeHint: 'Без моста чи мережі ВМ народжується без мережевих карт',
      fromDescriptionNetwork: 'Логічна мережа (fabric/мережа)',
      fromDescriptionSubmit: 'Створити',
      fromDescriptionError: 'Не вдалося створити ВМ',
      fromDescriptionDone: 'ВМ створено: {name}',
      fromDescriptionOpen: 'Відкрити ВМ',
      fromDescriptionDenied: 'Вам бракує vm.create',
      fromDescriptionStillRunning: 'Створення ще триває: чекаємо далі'
    },

    // Il MOTORE integrato (#28) — i backup dei dati che TVirt fa davvero.
    vm: {
      title: 'Резервні копії даних ВМ',
      titleOnVm: 'Резервні копії даних',
      empty:
        'Копій немає. Копія переносить диски, varstore UEFI і стан vTPM до призначення та переживає віртуальну машину.',
      colVm: 'ВМ',
      colCreated: 'Знята',
      colPhase: 'Підсумок',
      colDestination: 'Призначення',
      colContains: 'Вміст',
      colSize: 'Розмір',
      colOrigin: 'Походження',
      colMode: 'Тип',
      retentionChip: 'Зберігання',
      retentionHint:
        'Правило зберігання призначення може видалити цю копію не питаючи: вона народжена розкладом. Ручні копії не підмітаються ніколи.',
      policyRemoved: 'Policy видалено: {name}',
      policyRemovedHint:
        'Policy, що запланувала цей backup, більше не існує: жодна retention ним не керує (ніколи не підрізається автоматично) — видаліть його вручну, коли він більше не потрібен.',
      phase: {
        running: 'Виконується',
        complete: 'Завершена',
        error: 'Невдала'
      },
      origin: {
        manual: 'Вручну',
        schedule: 'За розкладом'
      },
      mode: {
        full: 'Повна',
        incremental: 'Інкрементна'
      },
      contains: {
        disks: 'Диски',
        varstore: 'Varstore UEFI',
        vtpm: 'Стан vTPM',
        snapshots: 'Знімки'
      },
      vmState: {
        stopped: 'ВМ вимкнена',
        running: 'ВМ працює (гаряче)'
      },
      artifactClass: { metadata: 'Метадані', data: 'Дані', secret: 'Секрет' },
      detail: {
        tabOverview: 'Зведення',
        tabArtefact: 'Артефакт',
        id: 'Ідентифікатор',
        scope: 'Область',
        vmState: 'Стан ВМ під час копіювання',
        pointInTime: 'Момент даних',
        completedAt: 'Завершена',
        node: 'Вузол, що копіював',
        error: 'Помилка',
        path: 'Каталог у сховищі',
        checksum: 'sha256 маніфесту',
        secretsExposed: 'Чутливий матеріал у відкритому вигляді',
        secretsExposedYes: 'Так — призначення не шифрує',
        secretsExposedNo: 'Ні',
        baseBackup: 'Базова копія',
        tabManifest: 'Маніфест',
        manifestHint:
          'Відкритий покажчик артефакту: один рядок на файл разом із його sha256. Каталог перевіряється і без TVirt — вистачає qemu-img, tar і jq.',
        manifestEmpty: 'Маніфест не перелічує файлів.',
        manifestError: 'Маніфест не читається',
        colEntry: 'Файл',
        colClass: 'Клас',
        colSha: 'sha256'
      },
      create: {
        action: 'Скопіювати зараз',
        title: 'Скопіювати зараз',
        submit: 'Запустити копіювання',
        destination: 'Призначення',
        destinationHint: 'Лише призначення, що приймають копії.',
        noDestinations: 'Жодне призначення не приймає копії: створіть його в Система → Checkpoints.',
        contentsHint:
          'Їдуть усі диски, varstore UEFI і стан vTPM. Останні два — сама суть: запечатаний гість мусить знову завантажитись.',
        error: 'Копіювання не запустилося',
        stillRunning: 'Копіювання ще триває — воно продовжиться, навіть якщо ви закриєте вікно.',
        vmRunning:
          'Машина {phase}: резервній копії потрібна стабільна ВМ — вимкнена для холодного копіювання, запущена для гарячого.'
      },
      restore: {
        action: 'Відновити',
        title: 'Відновити',
        intro: 'Відновлення незворотне. Оберіть, куди повернуться дані: у нову машину чи поверх вихідної.',
        modeNewVm: 'Відновити в НОВУ ВМ',
        modeNewVmHint:
          'Не чіпає нічого наявного — цим варіантом копію перевіряють. Новий ідентифікатор і щойно видані MAC.',
        modeOver: 'Перезаписати вихідну ВМ',
        modeOverHint: 'Знищує поточні дані цільової ВМ, без вороття. Машина має бути вимкнена.',
        newName: "Ім'я нової ВМ",
        newNameHint: 'Воно має бути вільним у цільовій області.',
        storage: 'Сховище для дисків',
        storageHint: "Обов'язково: маніфест записує розмір і формат диска, але ніколи — сховище, на якому він лежав.",
        metadataStorage: 'Сховище для varstore і vTPM',
        metadataStorageHint: 'Куди ляжуть ідентичність UEFI і стан vTPM.',
        sameAsStorage: 'Те саме, що й у дисків',
        bridge: 'Bridge хоста',
        bridgeHint:
          'Кожна записана мережева карта повернеться на цей bridge з новим MAC. Залишено порожнім — ВМ народиться без карт, і це безпечніше усталення.',
        overwriteTitle: 'Ви збираєтесь перезаписати цю ВМ',
        overwriteName: "Ім'я",
        overwriteId: 'Ідентифікатор',
        overwriteDisks: 'Диски, які буде перезаписано',
        overwriteNoDisks: 'Дисків немає.',
        overwriteKeeps:
          "Недоторканими лишаються ідентифікатор, ім'я, область, мережеві карти і MAC: копія — це ДАНІ, конфігурація — це checkpoint.",
        confirmField: "Ім'я ВМ",
        confirmHint: 'Введіть {name} для підтвердження.',
        targetLoading: 'Читання цільової ВМ…',
        targetRunning: 'Цільова ВМ {phase}: відновлення перезаписує байти під гостем, тому вимагає її вимкненою.',
        targetGone: 'Вихідну ВМ більше не прочитати: лишається відновлення в нову ВМ.',
        onlyComplete: 'Копія {phase}: відновлювати може лише завершена копія.',
        submitNewVm: 'Відновити в нову ВМ',
        submitOver: 'Перезаписати',
        error: 'Відновлення не запустилося',
        stillRunning: 'Відновлення ще триває — копіювання цілих дисків потребує часу.'
      }
    },
    guest: {
      title: {
        ct: 'Резервні копії даних контейнерів',
        app: 'Резервні копії даних App'
      },
      tabTitle: 'Резервні копії',
      empty: "Копій немає. Копія переносить сталі дані на призначення і переживає свій об'єкт.",
      colSubject: {
        ct: 'Контейнер',
        app: 'App'
      },
      colCreated: 'Створена',
      colPhase: 'Підсумок',
      colDestination: 'Призначення',
      colContains: 'Вміст',
      colSize: 'Розмір',
      colOrigin: 'Походження',
      policyRemoved: 'Policy видалено: {name}',
      policyRemovedHint:
        'Policy, що запланувала цей backup, більше не існує: жодна retention ним не керує (ніколи не підрізається автоматично) — видаліть його вручну, коли він більше не потрібен.',
      phase: {
        running: 'Виконується',
        complete: 'Завершена',
        error: 'Невдала'
      },
      origin: {
        manual: 'Ручна',
        schedule: 'Планова'
      },
      state: {
        stopped: "Об'єкт зупинено",
        running: "Об'єкт працює (заморожений)"
      },
      contains: {
        rootfs: 'Дерево rootfs',
        config: 'Конфігурація',
        volumes: 'Сталі томи',
        root: 'Сталий root'
      },
      artifactClass: {
        metadata: 'Метадані',
        data: 'Дані',
        secret: 'Секрет'
      },
      create: {
        action: 'Зробити копію зараз',
        title: 'Нова резервна копія',
        submit: 'Запустити копію',
        error: 'Копія не запустилася',
        destination: 'Призначення',
        destinationHint: 'Лише призначення, що приймають резервні копії даних.',
        noDestinations:
          'Жодне призначення не приймає резервних копій даних: додайте призначенню «Резервні копії даних».',
        hint: {
          ct: 'Подорожує все дерево rootfs, вірно (числові власники, xattr, ACL), плюс задекларована конфігурація в маніфесті. Робочий контейнер ЗАМОРОЖУЄТЬСЯ на весь час пакування: crash-consistent копія, задекларована.',
          app: 'Подорожують ЛИШЕ сталі томи (і сталий root), плюс конфігурація в маніфесті. Ефемерне виключено ратифікацією, і маніфест його називає; env-значення, задекларовані секретними, не подорожують.'
        },
        stillRunning: 'Копія ще виконується — пакування цілих дерев займає час.'
      },
      detail: {
        tabOverview: 'Огляд',
        tabManifest: 'Маніфест',
        id: 'Ідентифікатор',
        scope: 'Область',
        state: 'Стан при копіюванні',
        pointInTime: 'Дані на мить',
        completedAt: 'Завершена',
        node: 'Вузол, що копіював',
        error: 'Помилка',
        path: 'Каталог у сховищі',
        checksum: 'sha256 маніфеста',
        manifestHint: 'Індекс артефакту: по запису на файл з його sha256 — без хешів «копія є» — акт віри.',
        manifestError: 'Маніфест не читається',
        manifestEmpty: 'У маніфесті немає артефактів.',
        colEntry: 'Файл',
        colClass: 'Клас',
        colSha: 'sha256',
        excluded: 'Виключено ратифікацією (не подорожує)',
        secretKeys: 'Пропущені секретні env-ключі (#307) — введіть їх знову після відновлення'
      },
      restore: {
        action: 'Відновити',
        title: 'Відновлення',
        submit: 'Відновити',
        error: 'Відновлення не запустилося',
        stillRunning: 'Відновлення ще виконується — розпакування цілих дерев займає час.',
        onlyComplete: 'Копія {phase}: відновити може лише завершена копія.',
        asNew: {
          ct: 'У НОВИЙ контейнер — нічого не руйнує: жест, яким перевіряють копію',
          app: 'У НОВИЙ App — нічого не руйнує: жест, яким перевіряють копію'
        },
        over: {
          ct: 'ПОВЕРХ вихідного контейнера — замінюється все дерево rootfs',
          app: 'ПОВЕРХ вихідного App — замінюється вміст кожного сталого тому'
        },
        name: "Ім'я нового об'єкта",
        storage: 'Сховище',
        storageHint: 'Куди приземляються відновлені дані — маніфест ніколи не записує втрачений pool.',
        storageDeclared: 'Сховища, задекларовані в маніфесті',
        bridge: 'Міст хоста',
        bridgeHint:
          "Кожна записана картка повертається на цей міст зі свіжим MAC. Порожньо = народжується непід'єднаним, найбезпечніше за замовчуванням.",
        node: 'Вузол',
        nodeHint: 'Член, на якому App відроджується: вузол — ідентичність кластера і ніколи не приходить з маніфеста.',
        secretKeysWarning:
          'Env-значення, задекларовані секретними, не подорожують у копії: відроджена копія хоче їх знову введеними (журнал задачі називає ключі).',
        overInventory: "Ви збираєтеся перезаписати цей об'єкт",
        confirmType: 'Введіть {name} для підтвердження',
        targetGone: "Вихідний об'єкт більше не читається: залишається відновлення як нового.",
        targetLoading: "Читання цільового об'єкта…",
        targetRunning: "Цільовий об'єкт працює: відновлення замінює байти під гостем і хоче його зупиненим."
      }
    }
  }
}
